import { render } from "./EmptyPanel.vue?vue&type=template&id=e0585536&scoped=true"
import script from "./EmptyPanel.vue?vue&type=script&lang=js"
export * from "./EmptyPanel.vue?vue&type=script&lang=js"

import "./EmptyPanel.vue?vue&type=style&index=0&id=e0585536&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0585536"]])

export default __exports__